import { useQuery } from '@tanstack/react-query'
import { fetchUserSummary } from '../api/api'

const USER_SUMMARY_STALE_TIME = 5 * 60 * 1000

export function useUserSummary(enabled = true) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['user-summary'],
    queryFn: fetchUserSummary,
    staleTime: USER_SUMMARY_STALE_TIME,
    enabled,
  })

  return { userSummary: data ?? null, isLoading, isError }
}
